import React from "react";
import { getUploadsUrl } from "../../config";

export default function ArticleBanner({ post }) {
    const img = post && (post.feature_image_url || post.feature_image);
    if (!post) {
        return (
            <div className="article-banner">
                <div className="graphic skeleton">
                    <div className="placeholder-box" style={{height:240, borderRadius:8}} />
                    <span className="dots"></span>
                </div>
            </div>
        );
    }

    return (
        <div className="article-banner">
            <div className="graphic">
                {img ? (
                    <img loading="lazy" src={getUploadsUrl('posts', img)} alt={post.feature_image_name || post.title} style={{width:'100%', height:'100%', objectFit:'cover'}} />
                ) : (
                    <>
                        <span className="blob blob-banner2"></span>
                        <span className="blob blob-banner3"></span>
                    </>
                )}
                <span className="dots"></span>
            </div>
        </div>
    );
}
